/**
 * Funkce pro převedení prvního písmena řetězce na velké.
 * @param str Převáděný řetězec
 */
export const capitalize = (str: string) => str.charAt(0).toLocaleUpperCase() + str.slice(1);
